(() => {
  if (window.location.hash === "#homepage-quizz") {
    window.location.hash = ""; // Remove o hash
  }

  document.addEventListener("DOMContentLoaded", function () {
    const splideEl = document.querySelector("#quizzModal .splide");
    const splide = new Splide(splideEl, {
      type: "slide",
      perPage: 1,
      arrows: false,
      drag: false,
      pagination: false,
      focus: "center",
      autoHeight: true,
    });
    splide.on("active", function (slide) {
      var list = document.querySelector(".meal-plan-quizz__form .splide__list");
      var activeSlide = slide.slide;
      list.style.height = activeSlide.offsetHeight + "px";
    });
    splide.mount();

    const continue_buttons = splideEl.querySelectorAll(
      ".form-controls-wrapper .button-primary"
    );
    const back_buttons = splideEl.querySelectorAll(
      ".form-controls-wrapper .button-secondary"
    );
    continue_buttons.forEach((btn) => {
      btn.addEventListener("click", function () {
        splide.go(">");
      });
    });
    back_buttons.forEach((btn) => {
      btn.addEventListener("click", function () {
        splide.go("<");
      });
    });
    const inputs = splideEl.querySelectorAll(".form-wrapper input");
    inputs.forEach((input) => {
      input.addEventListener("input", function () {
        const mealPlanFormAll = document.querySelectorAll(
          "form.meal-plan-quizz__form-wrapper"
        );
        mealPlanFormAll.forEach((mealPlanForm) =>
          mealPlanForm.classList.remove("most-recent")
        );
        input
          .closest("form.meal-plan-quizz__form-wrapper")
          .classList.add("most-recent");
        const wrapper = this.closest("li");
        const continue_button = wrapper.querySelector(".button-primary");
        continue_button.disabled = false;
      });
    });

    const mealPlanForms = document.querySelectorAll(
      "form.meal-plan-quizz__form-wrapper"
    );
    mealPlanForms.forEach((mealPlanForm) => {
      mealPlanForm.addEventListener("submit", function (e) {
        e.preventDefault();
      });
    });

    // delay function
    function delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }
    window.addEventListener("hashchange", async function () {
      if (window.location.hash == "#homepage-quizz") {
        const heading = document.querySelector(
          "#quizzModal .meal-plan-quizz__heading"
        );
        const quizzWrapper = document.querySelector(
          "#quizzModal .component-meal-plan-quizz--wrapper"
        );
        quizzWrapper.classList.add("completed");
        heading.innerHTML =
          "<b>Let's get started!</b><span>Checking the best plan for you...</span><small>You'll be redirected in a few seconds.</small>";
        splide.go(">");
        const mealPlanForm = document.querySelector(
          "#quizzModal form.meal-plan-quizz__form-wrapper"
        );
        const formData = new FormData(mealPlanForm);
        const data = {};
        formData.forEach((value, key) => {
          data[key] = value;
        });
        const mealPlan = getMealPlan(data);
        if (data) userTrack(data);
        await delay(1800);
        if (mealPlan) {
          localStorage.setItem("homePageMealPlanQuizz", true);
          const name = data.name ? data.name : "default";
          window.location.href = `/discount/INTRO_80?redirect=/pages/start-my-plan/${mealPlan}&name=${name}`;
        }
      }
    });
  });

  function userTrack(data) {
    try {
      let _learnq = window._learnq || [];
      _learnq.push([
        "identify",
        {
          $consent: ["email", "sms"],
          Gender: data.gender,
          "Exercise-Level": data.exercise_level,
          "User-Goal": data.current_goal,
        },
      ]);
    } catch (e) {
      console.error(e);
    }
  }
  function getMealPlan(data) {
    try {
      return mealPlansFilter[data.gender][data.exercise_level][
        data.current_goal
      ];
    } catch (e) {
      return null;
    }
  }

  const mealPlansFilter = {
    male: {
      "4-5": {
        "fat-loss": "lean-muscle",
        "gain-muscle": "clean-bulking",
        "eat-healthy": "pro-athlete",
      },
      "2-3": {
        "fat-loss": "lean-muscle",
        "gain-muscle": "pro-athlete",
        "eat-healthy": "lean-muscle",
      },
      zero: {
        "fat-loss": "low-carb",
        "gain-muscle": "pro-athlete",
        "eat-healthy": "power",
      },
    },
    female: {
      "4-5": {
        "fat-loss": "lean-muscle",
        "gain-muscle": "pro-athlete",
        "eat-healthy": "lean-muscle",
      },
      "2-3": {
        "fat-loss": "low-carb",
        "gain-muscle": "lean-muscle",
        "eat-healthy": "power",
      },
      zero: {
        "fat-loss": "low-carb",
        "gain-muscle": "lean-muscle",
        "eat-healthy": "low-carb",
      },
    },
  };
})();
